import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE_BY_KEY } from './shared.jsx';

export default function RedesignShell({ children }) {
  const navigate = useNavigate();

  const onNav = useCallback((key) => {
    const path = ROUTE_BY_KEY[key] || '/';
    navigate(path);
  }, [navigate]);

  const content = typeof children === 'function' ? children({ onNav }) : children;

  return <div className="redesign-root">{content}</div>;
}
